import {
    SHOW_ERROR,
    ADD_PRESENTATION,
    FETCH_PRESENTATIONS,
    EDIT_PRESENTATION,
    ADD_CUSTOMER_SEGMENT,
    EDIT_CUSTOMER_SEGMENT,
    DELETE_CUSTOMER_SEGMENT,
} from './types';
import errorObject from '../components/helpers/errorObject';
import auth from '../apis/auth';

export const addPresentation = (formValues) => async dispatch => {
    await auth.post('/api/presentation/create_presentation', formValues)
        .then(response => {
            dispatch({ type: ADD_PRESENTATION, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchPresentations = () => async dispatch => {
    await auth.get('/api/presentation/get_presentations')
        .then(response => {
            dispatch({ type: FETCH_PRESENTATIONS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const editPresentation = (id, formValues) => async dispatch => {
    await auth.patch(`/api/presentation/update_presentation?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: EDIT_PRESENTATION, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const addCustomerSegment = (id, formValues) => async dispatch => {
    await auth.patch(`/api/presentation/add_customer_segment?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: ADD_CUSTOMER_SEGMENT, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const editCustomerSegment = (id, customer_segment_id, formValues) => async dispatch => {
    await auth.patch(`/api/presentation/update_customer_segment?id=${id}&customer_segment_id=${customer_segment_id}`, formValues)
        .then(response => {
            dispatch({ type: EDIT_CUSTOMER_SEGMENT, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const deleteCustomerSegment = (id, customer_segment_id) => async dispatch => {
    await auth.delete(`/api/presentation/delete_customer_segment?id=${id}&customer_segment_id=${customer_segment_id}`)
        .then(response => {
            dispatch({ type: DELETE_CUSTOMER_SEGMENT, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchValueModelDisplay = async (id, variables) => {
    try {
      const response = await auth.get(
        `/api/value/view_value_model?id=${id}&variables=${JSON.stringify(variables)}`
      );
      return response.data;
    } catch (error) {
      // Handle the error here or rethrow it
      throw error;
    }
  };